module.exports = __webpack_public_path__ + "img/Milborne.3f01b4ca.jpg";